<div class="login-main">
    <div class="login-shared-main-body login-shared-scroll-container">
        <div *ngIf="form" class="login-form-container" [style.translate]="'-' + currentStepIndex + '00%'">
            <form [formGroup]="form" (ngSubmit)="onSubmit()" class="login-main-body-form-container">
                <ng-container *ngIf="currentStepIndex == 0">
                    <div class="login-shared-intro-text">Validate Identity</div>
                    <app-alert-error *ngIf="answersAreInvalid" [wide]="true">Unable to validate identity</app-alert-error>
                    <app-alert-error *ngIf="accountNotSetUp">
                        Your account isn't set up yet.<br />
                        Please <a [routerLink]="['../SignUp/Start']">Create an Account</a> to get started.
                    </app-alert-error>
                    <app-login-enter-pii [formArray]="form.controls.piiQuestions"></app-login-enter-pii>

                    <div class="recaptcha-ctr" nbRecaptcha key="6Lfwp0UUAAAAAPRBa_O6SZRyYc6qWZ7qqd0rAXy2" formControlName="captcha"></div>
                    <div class="login-recover-email-address-button-container">
                        <button type="submit" [disabled]="!form.valid" class="login-btn-submit">
                            VALIDATE
                        </button>
                    </div>
                </ng-container>
            </form>
            <div class="login-main-body-form-container">
                <ng-container *ngIf="currentStepIndex == 1">
                    <div class="login-shared-intro-text">Recovered Email</div>
                    <mat-form-field class="login-form-field">
                        <mat-icon matIconPrefix color="primary" fontSet="fas" fontIcon="fa-user" class="login-input-icon"></mat-icon>
                        <input matInput readonly [formControl]="emailAddressControl" />
                    </mat-form-field>
                    <a routerLink=".." class="login-btn-submit">LOGIN</a>
                </ng-container>
            </div>
        </div>
        <div class="login-workflow-footer">
            <a routerLink="..">
                <i class="fa-solid fa-house login-workflow-footer-icon"></i>
            </a>
        </div>
    </div>
</div>
